import React from "react";
import { Link, Redirect } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import CloseIcon from '@material-ui/icons/Close';
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Snackbar from '@material-ui/core/Snackbar';
import firebase, { auth, db } from '../../settings/firebase';
import AuthForm from "../../components/Authentication/AuthForm";
import LoginProvider, { SignupLoginHandler } from "../../components/Authentication/LoginProvider";
import "./Signup.css";
import getQueryStrings from "../../utils/getQueryStrings";

// アカウントの開設画面
class Signup extends React.Component {
  constructor(props) {
    super(props);
    const query = window.location.search;
    // 遷移元ページ
    let redirect = "/";
    if(props.redirect) {
      redirect = props.redirect;
    } else if(query) {
      redirect = getQueryStrings(query)['redirect'];
    }
    this.state = {email: '', password: '', name: '', isSignin: false, open: false, isChecking: false,
      redirect: decodeURIComponent(redirect), checkedterms: false, enabledlogin: false, sentmail: false
    };

    this.mailChange = this.mailChange.bind(this);
    this.passChange = this.passChange.bind(this);
    this.nameChange = this.nameChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.googleLoginHandler = this.googleLoginHandler.bind(this);
    this.twitterLoginHandler = this.twitterLoginHandler.bind(this);
    this.facebookLoginHandler = this.facebookLoginHandler.bind(this);
  }

  mailChange(event) {
    const el = this.checkValidation();
    this.setState({email: event.target.value, enabledlogin: el});
  }

  passChange(event) {
    const el = this.checkValidation();
    this.setState({password: event.target.value, enabledlogin: el});
  }

  nameChange(event) {
    const el = this.checkValidation();
    this.setState({name: event.target.value, enabledlogin: el});
  }

  // アカウントの開設
  handleSubmit(event) {
    event.preventDefault();
    // alert('A name was submitted: ' + this.state.email);
    // Sign Up
    auth.createUserWithEmailAndPassword(this.state.email, this.state.password)
    .then(async (userCredential) => {
      // Signed in
      firebase.auth().currentUser.sendEmailVerification().then(() => {
        console.log("確認メールを送信しました。");
        this.setState({sentmail: true})
      });
      var user = userCredential.user;
      const displayid = user.uid
      await db.collection("users").doc(user.uid).set({
        pageUrl: "",
        name: this.state.name,
        displayid: displayid,
        avatarUrl: "",
        intro: "",
        favorite: [],
        follow: 0,
        follower: 0,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      });
      await db.collection("displayids").doc(displayid).set({
        uid: user.uid,
      });
      this.setState({isSignin: true});
    })
    .catch((error) => {
      console.log(error);
    });
  }

  /* サードパーティ製プロバイダによる認証 */
  // Google認証
  async googleLoginHandler() {
    const provider = new firebase.auth.GoogleAuthProvider();
    this.setState({isChecking: true});
    await auth.signInWithPopup(provider).then(async (result) => {
      console.log("認証成功: " + result.user.uid);
      SignupLoginHandler(result.user);
      this.setState({isSignin: true});
    }).catch((error) => {
      console.log(error)
      this.setState({open: true, isChecking: false});
    });
  }

  // Twitter認証
  async twitterLoginHandler() {
    const provider = new firebase.auth.TwitterAuthProvider();
    this.setState({isChecking: true});
    firebase.auth().signInWithPopup(provider).then((result) => {
      console.log("認証成功: " + result.user.uid);
      SignupLoginHandler(result.user);
      this.setState({isSignin: true});
    }).catch((error) => {
      console.log(error)
      this.setState({open: true, isChecking: false});
    });
  }

  // Facebook認証
  async facebookLoginHandler() {
    const provider = new firebase.auth.FacebookAuthProvider();
    this.setState({isChecking: true});
    firebase.auth().signInWithPopup(provider).then((result) => {
      console.log("認証成功: " + result.user.uid);
      SignupLoginHandler(result.user);
      this.setState({isSignin: true});
    }).catch((error) => {
      console.log(error)
      this.setState({open: true, isChecking: false});
    });
  }  

  alertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({open: false});
  };

  // メールアドレスとパスワードのバリデーション
  checkValidation = (checked = this.state.checkedterms) => {
    let el = false;
    if (checked) {
      if (this.state.email.match(/^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/) !== null
        && this.state.password.match(/^[a-zA-Z0-9@!#$%&*\-_]{6,}$/) !== null && this.state.name !== "" ) {
        el = true;
      }
    }
    return el;
  }

  changeCheckedterms = (event) => {
    const el = this.checkValidation(!this.state.checkedterms);
    this.setState({checkedterms: !this.state.checkedterms, enabledlogin: el});
  }

  render() {
    return (
      <Grid container justifyContent="center">
        { this.state.isSignin === true ?
          <Redirect to={"/settings?skippable=true&intro=1&redirect=" + encodeURIComponent(this.state.redirect)} />
        :
          <Grid item maxwidth="xs">
            <div>
              <React.Fragment>
                <Typography className={"center-item"} style={{marginTop: "20px"}} component="h1" variant="h5">
                  SelectBook
                </Typography>
                <div>
                  {this.state.isChecking?
                    <p>認証中...</p>
                  :
                    <LoginProvider
                      google={this.googleLoginHandler}
                      twitter={this.twitterLoginHandler}
                      facebook={this.facebookLoginHandler}
                    />
                  }
                </div>
                <AuthForm
                  onChangeName={this.nameChange}
                  handleSubmit={this.handleSubmit}
                  onChangeMail={this.mailChange}
                  onChangePass={this.passChange}
                  onChangeTerms={this.changeCheckedterms}
                  checkedterms={this.state.checkedterms}
                  enabledlogin={this.state.enabledlogin}
                  type={"無料登録！"}
                />
                <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                open={this.state.open}
                autoHideDuration={5000}
                onClose={this.alertClose}
                message="サインアップできませんでした。もう一度やり直してください。"
                action={
                  <React.Fragment>
                    <IconButton size="small" aria-label="close" color="inherit" onClick={this.alertClose}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </React.Fragment>
                }
              >
              </Snackbar>
                <p>
                  すでにアカウントをお持ちの方は
                  <Link style={{color: "#c79100"}}
                    to={this.state.redirect === "/" ? "/signin" : "/signin?redirect=" + encodeURIComponent(this.state.redirect)}
                  >
                    こちら
                  </Link>
                </p>
              </React.Fragment>
            </div>
          </Grid>
        }
      </Grid>
    );
  }
}

export default Signup;